<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-100 flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="logo flex">
        <a href="/" class="router-link-active">
          <img
            src="https://static.triple-a.io/assets/images/TripleA-main-logo-transparent.png"
            alt="logo"
            style="max-width: 200px"
            class
          />
        </a>
      </div>

      <div>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <!--                        <div class="vx-col hidden lg:block lg:w-1/2">-->
            <!--                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
            <!--                        </div>-->
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              style="border: 1px solid lightgrey; max-width: 400px"
            >
              <div class="p-8">
                <div
                  class="vx-card__title mb-8"
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                  "
                  v-if="!loggedOut"
                >
                  <br />
                  <br />
                  <h4>Are you sure you want to log out?</h4>
                  <vs-button
                    type="gradient"
                    @click="confirmLogout()"
                    style="margin: auto; margin: 20px 0; background: #005294"
                  >
                    Log out
                  </vs-button>
                  <br />
                  <br />
                  <vs-button
                    type="border"
                    color="primary"
                    @click="goBack()"
                    class="small"
                    style="margin: auto"
                  >
                    Return to Dashboard
                  </vs-button>
                </div>

                <template v-else>
                  <div class="vx-card__title mb-8">
                    <br />
                    <br />
                    <h4 class="mb-4">You have logged out</h4>
                    <p>See you again soon!</p>
                    <br />
                    <br />
                    <br />
                    <vs-button
                      type="border"
                      color="primary"
                      @click="goLogin()"
                      class="small"
                    >
                      Login again
                    </vs-button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      loggedOut: false,
    };
  },
  mounted() {
    this.loggedOut = this.$store.state.activeUser === null;
  },
  methods: {
    async confirmLogout() {
      this.logoutUser();
    },
    goBack() {
      this.$router.back();
    },
    goLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss">
.logo {
  a {
    display: inline-block;
    margin: auto auto 50px;
  }

  img {
    display: inline-block;
    width: 220px;
  }
}

#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
